export const SESSION_PROFILE_TIMEOUT_MS = 10000;

export async function loadSessionProfile(token, { signal, timeoutMs = SESSION_PROFILE_TIMEOUT_MS } = {}) {
    const controller = new AbortController();
    const cancel = () => controller.abort();
    signal?.addEventListener('abort', cancel, { once: true });
    if (signal?.aborted) controller.abort();
    let timer;
    try {
        return await Promise.race([
            (async () => {
                const response = await fetch('/api/agents/me', {
                    headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
                });
                const data = await response.json().catch(() => null);
                if (!response.ok) {
                    const error = new Error('No hemos podido comprobar tu sesión. Reintenta la conexión.');
                    // A gateway failure must not erase a valid saved session.
                    error.isAuthError = [401, 403].includes(response.status)
                        && Boolean(data?.message || data?.error) && !data?.external_error;
                    throw error;
                }
                if (!data || typeof data.id !== 'string' || !data.id) {
                    throw new Error('No hemos podido recuperar tu perfil. Reintenta la conexión.');
                }
                return data;
            })(),
            new Promise((_, reject) => {
                timer = setTimeout(() => {
                    reject(new Error('La conexión está tardando demasiado. No hemos podido comprobar tu sesión.'));
                    controller.abort();
                }, timeoutMs);
            }),
        ]);
    } finally {
        clearTimeout(timer);
        signal?.removeEventListener('abort', cancel);
    }
}
